/**
 * Kudago js config stub
 */

module.exports = window.kudago;
